<template>
    <div class="row" v-if="show">
        <div class="col-md-6 text-center p-4">
            <h3>Proporsi Tipe Komplain</h3>
            <DashboardPie 
                :chartId="total.id"
                :chartData="total.data"
                :datasetIdKey="total.datasetIdKey"
                :width="chart.width"
                :height="chart.height"
                :cssClasses="chart.cssClasses"
                :styles="chart.styles"
                :plugins="chart.plugins"
            />
        </div>
        <div class="col-md-6 text-center p-4">
            <v-autocomplete class="label-label mb-0"
                v-model="selectedOperator"
                :items="operatorList" 
                hide-selected
                item-text="name"
                item-value="_id"
                label="Operator"
                :loading="isLoadingTotalOp"
            ></v-autocomplete>
            <h3 v-if="!isLoadingTotalOp">{{ selectedOperator }}</h3>
            <DashboardPie 
                :chartId="totalOp.id"
                :chartData="totalOp.data"
                :datasetIdKey="totalOp.datasetIdKey"
                :width="chart.width"
                :height="chart.height"
                :cssClasses="chart.cssClasses"
                :styles="chart.styles"
                :plugins="chart.plugins"
            />
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import { mapState } from 'vuex'

    // import DashboardBar from "./DashboardBar.vue"
    import DashboardPie from "./DashboardPie.vue"
    // import DashboardDoughnut from "./DashboardDoughnut.vue"
    // import DashboardLine from "./DashboardLine.vue"

    var moment = require('moment');

    export default {
        props: ['show', 'selectedStartDate', 'selectedMonth', 'selectedFilter'],

        computed: {
            ...mapState({
                sessionInfo: state => state.session.sessionInfo,
                operatorList: state => state.operator.operatorList,
            })
        },

        data: function () {
            return {
                selectedOperator: String(),

                isLoadingTotalOp: false,

                chart: {
                    width: 400,
                    height: 400,
                    cssClasses: String(),
                    styles: Object(),
                    plugins: Array(),
                },

                total: {
                    id: 'total',
                    datasetIdKey: 'total',
                    data: {
                        labels: [],
                        datasets: [{
                            backgroundColor: ['#198754', '#dc3545', '#0dcaf0', '#6732d7', '#0d6efd', '#eda247', '#fc1fa9', '#654321', '#66cccc', '#ccff00', '#003366'],
                            data: []
                        }]
                    },
                },

                totalOp: {
                    id: 'total',
                    datasetIdKey: 'total',
                    data: {
                        labels: [],
                        datasets: [{
                            backgroundColor: ['#198754', '#dc3545', '#0dcaf0', '#6732d7', '#0d6efd', '#eda247', '#fc1fa9', '#654321', '#66cccc', '#ccff00', '#003366'],
                            data: []
                        }]
                    },
                },
            }
        },


        watch: {
            async selectedOperator(val) {
                if(val) {
                    await this.loadDataComplainByDay(val)
                } else {
                    this.totalOp = {
                        id: 'total',
                        datasetIdKey: 'total',
                        data: {
                            labels: [],
                            datasets: [{
                                backgroundColor: ['#198754', '#dc3545', '#0dcaf0', '#6732d7', '#0d6efd', '#eda247', '#fc1fa9', '#654321', '#66cccc', '#ccff00', '#003366'],
                                data: []
                            }]
                        }
                    }

                }

            }
        },

        mounted() {

        },

        methods: {
            loadDataComplainByDay: async function(operatorId) {
                const params = Object()

                if(this.selectedFilter == 'month') {
                    var selectedMonth = this.selectedMonth.split('-');

                    params.startDate = moment([selectedMonth[0], selectedMonth[1] - 1]).startOf('month').format();
                    params.endDate = moment([selectedMonth[0], selectedMonth[1] - 1]).endOf('month').format();
                } else {
                    params.startDate = this.selectedStartDate ? moment(this.selectedStartDate).format() : ""
                    params.endDate = this.selectedStartDate ? moment(this.selectedStartDate).endOf('day').format() : ""
                }

                if(operatorId) {
                    params.operatorId = operatorId
                    this.isLoadingTotalOp = true
                }

                try {
                    
                    const { data } = await axios.get(process.env.VUE_APP_API_URL + '/sessioninfo/complain/day', {
                        params
                    })

                    // let labels = [
                    //     { id: 'DEFECT', label: 'Produk Cacat', value: 0 }, 
                    //     { id: 'SHIPPING', label: 'Pengiriman', value: 0 }, 
                    //     { id: 'WEBSITE', label: 'Website', value: 0 }, 
                    //     { id: 'APPS', label: 'Aplikasi', value: 0 }, 
                    //     { id: 'CS_BAD_SERVICE', label: 'Pelayanan Tidak Sesuai', value: 0 }, 
                    //     { id: 'STOCK', label: 'Stok Produk', value: 0 }, 
                    //     { id: 'POINT', label: 'Poin', value: 0 }, 
                    //     { id: 'RETURN', label: 'Retur', value: 0 }, 
                    //     { id: 'PROMO', label: 'Promo', value: 0 }, 
                    //     { id: 'PAYMENT', label: 'Pembayaran', value: 0 }, 
                    //     { id: 'OTHER', label: 'Lainnya', value: 0 }
                    // ]

                    // data.forEach(e => {
                    //     const index = labels.findIndex(el => el.id == e._id)

                    //     labels[index].value = e.count
                    // })

                    if(!operatorId) {
                        const labels = this.formatComplainTypeEng(data)
    
                        this.total.data.labels = labels.map(e => e.label)
                        this.total.data.datasets[0].data = labels.map(e => e.count)
                    } else {
                        const labels = this.formatComplainTypeEng(data)
    
                        this.totalOp.data.labels = labels.map(e => e.label)
                        this.totalOp.data.datasets[0].data = labels.map(e => e.count)
                    }

                    this.isLoadingTotalOp = false
                } catch (error) {
                    console.log("error sales return by day", error);
                }
            },

            formatComplainTypeEng(data) {
                return data.map(e => {
                    if (e._id == 'DEFECT') e.label = 'PRODUK_CACAT'
                    if (e._id == 'SHIPPING') e.label = 'PENGIRIMAN'
                    if (e._id == 'WEBSITE') e.label = 'WEBSITE'
                    if (e._id == 'APPS') e.label = 'APLIKASI'
                    if (e._id == 'CS_BAD_SERVICE') e.label = 'PELAYANAN_TIDAK_SESUAI'
                    if (e._id == 'STOCK') e.label = 'STOK_PRODUK'
                    if (e._id == 'POINT') e.label = 'POIN'
                    if (e._id == 'RETURN') e.label = 'RETUR'
                    if (e._id == 'PROMO') e.label = 'PROMO'
                    if (e._id == 'PAYMENT') e.label = 'PEMBAYARAN'
                    if (e._id == 'OTHER') e.label = 'LAINNYA'

                    return e
                })
            },

            setOperatorColor: function(id) {
                // '#198754' hijau, 
                // '#0dcaf0' biru,
                // '#dc3545' merah,
                // '#ced4da' abu,

                // '#0d6efd' biru tua (Add)
                // '#6732d7' ungu (Add)
                // '#eda247' orange (Add)
                // '#fc1fa9' pink (Add)
                // '#654321' coklat (Add)
                // '#003366' navy (Add)
                // '#065535' hijau tua
                // '#ccff00' stabilo
                // '#66cccc' telor asin
                
                if(id == 'resti_nurjamilah') {
                    // pink
                    return '#fc1fa9'
                } else if(id == 'sahara2') {
                    // ungu
                    return '#6732d7'
                } else if(id == 'desni_aghni_amalinisa') {
                    // biru tua
                    return '#0d6efd'
                } else if(id == 'ulfiah_alamatus_sa_adah') {
                    // navy
                    return '#003366'
                } else if(id == 'selindri_nurifatikah3') {
                    // orange
                    return '#eda247'
                } else if(id == 'redi') {
                    // coklat
                    return '#654321'
                } else if(id == 'ingga_bia_putri') {
                    // stabilo
                    return '#ccff00'
                } else if(id == 'hervin') {
                    // telor asin
                    return '#66cccc'
                } else {
                    // hijau
                    return '#198754'
                }
            },
        },

        components: {
            // DashboardBar,
            DashboardPie,
            // DashboardDoughnut,
            // DashboardLine
        },

    }

</script>
